import Plot from "react-plotly.js";
import { addHours } from "../utils";

// LMA Theme colors
const lmaColors = {
  dark: '#041c2c',
  gold: '#B09879',
  gray: '#58585b',
  light: '#f5f5f5',
  positive: '#B09879', // gold for positive
  negative: '#041c2c', // dark for negative
};

export function ListingDetailsChart({ timeseries, priceChange }) {
  const x = timeseries.map((el) => el.dt);
  const y = timeseries.map((el) => el.price);
  const col = priceChange > 0 ? lmaColors.positive : lmaColors.negative;

  let priceForManualRange = NaN;

  if (Math.abs(priceChange) === 0 || isNaN(priceChange)){
    for(let i =0;i<timeseries.length;i++){
      if (!isNaN(timeseries[i].price)){
        priceForManualRange = timeseries[i].price;
        break;
      }
    }
  }

  const manualRangeMin = priceForManualRange * 0.9;
  const manualRangeMax = priceForManualRange * 1.1;
  const manualRange = [manualRangeMin, manualRangeMax];

  const layout = {
    autosize: true,
    title: {
      text: "PRICE HISTORY ($)",
      font: {
        family: 'Inter, system-ui, -apple-system, sans-serif',
        size: 14,
        color: lmaColors.dark,
      },
    },
    font: {
      family: 'Inter, system-ui, -apple-system, sans-serif',
      color: lmaColors.gray,
    },
    xaxis: {
      autotick: true,
      automargin: true,
      tickfont: {
        family: 'Inter, system-ui, -apple-system, sans-serif',
        size: 11,
        color: lmaColors.gray,
      },
      gridcolor: '#e8e8e8',
      linecolor: '#e8e8e8',
    },
    yaxis: {
      automargin: true,
      tickfont: {
        family: 'Inter, system-ui, -apple-system, sans-serif',
        size: 11,
        color: lmaColors.gray,
      },
      gridcolor: '#e8e8e8',
      linecolor: '#e8e8e8',
    },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    margin: { t: 40, r: 20, b: 40, l: 60 },
  };

  if (Math.abs(priceChange) > 0){
    layout.yaxis['autorange'] = true;
  } else {
    layout.yaxis['range'] = manualRange;
  }

  if (timeseries.length === 1){
    layout.xaxis['tickformat'] = '%H:%M:%S '
    layout.xaxis['range'] = [addHours(timeseries[0].dt,-0.5),addHours(timeseries[0].dt,0.5)];
  }

  return (
    <Plot
      style={{width: "100%", height: "100%"}}
      data={[
        {
          type: "scatter",
          x: x,
          y: y,
          mode: "lines",
          name: "Price",
          line: {
            color: col,
            width: 2,
          },
        },
      ]}
      layout={layout}
      config={{ displayModeBar: false }}
    />
  );
}
